import React from 'react';
import { motion } from 'framer-motion';
import './ui.css';

interface BrandedLoaderProps {
  message?: string;
  fullScreen?: boolean;
}

export const BrandedLoader: React.FC<BrandedLoaderProps> = ({
  message = 'Loading Workspace...',
  fullScreen = true,
}) => {
  return (
    <div className={`branded-loader-container ${fullScreen ? 'fullscreen' : 'inline'}`}>
      <motion.div
        className="loader-card glass-effect"
        initial={{ opacity: 0, scale: 0.92 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.4, ease: 'easeOut' }}
      >
        {/* Pulsing Aura Glow Behind Logo */}
        <div className="loader-logo-wrapper">
          <motion.div
            className="loader-logo-glow"
            animate={{
              scale: [1, 1.15, 1],
              opacity: [0.3, 0.7, 0.3],
            }}
            transition={{
              duration: 2.5,
              repeat: Infinity,
              ease: 'easeInOut',
            }}
          />
          <img
            src="/drishti-logo.png"
            alt="Drishti Studios Logo"
            className="loader-logo-img"
          />
        </div>

        {/* Title & Subtitle */}
        <h2 className="loader-title">Drishti Business OS</h2>
        <p className="loader-message">{message}</p>
        <span className="loader-caption">Powered by Drishti Studios</span>

        {/* Animated Gold/Purple Progress Bar */}
        <div className="loader-progress-track">
          <motion.div
            className="loader-progress-bar"
            initial={{ x: '-100%' }}
            animate={{ x: '100%' }}
            transition={{
              repeat: Infinity,
              duration: 1.6,
              ease: 'easeInOut',
            }}
          />
        </div>
      </motion.div>
    </div>
  );
};
